import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom';
import Header from '../../components/layout/header/header';
import Footer from '../../components/layout/footer/footer';
import CookiesBanner from '../../components/layout/banner/cookies';
import Page from '../page/page';
import Post from '../post/post';
import ErrorBoundary from './error';
import styles from './app.scss';

class App extends Component {
  componentWillMount() {
    if (window.baseTitle === undefined) {
      window.baseTitle = document.title;
    }
  }

  render() {
    return (
      <div className={styles.body}>
        <Header/>
        <ErrorBoundary>
          <main className={styles.main}>
            <Switch>
              <Route exact path='/' component={Page}/>
              <Route exact path='/p/:slug' component={Post}/>
              <Route exact path='/:slug' component={Page}/>
            </Switch>
          </main>
        </ErrorBoundary>
        <Footer/>
        <CookiesBanner/>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/containers/app/app.js